import { html } from 'lit';

export const MoreIndicator = html`<svg
  width="34"
  height="29"
  viewBox="0 0 34 29"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M3 14.4292L16.8345 18.9019C17.0345 18.9665 17.2498 18.9665 17.4498 18.9019L31.2843 14.4292"
    stroke="black"
    stroke-opacity="0.3"
    stroke-width="5"
    stroke-linecap="round"
  />
</svg>`;
